import * as Sentry from '@sentry/react';
import { IGNORE_ERRORS } from './sentryIgnore';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  // Third-party / browser-extension noise — not our code. See sentryIgnore.ts.
  ignoreErrors: IGNORE_ERRORS,
});

export { Sentry };
